import React, { useState, useEffect } from "react";
import grey from "@material-ui/core/colors/grey";
import {
    withStyles,
    makeStyles,
    createStyles,
    useTheme,
  } from "@material-ui/core/styles";
  import Box from "@material-ui/core/Box";
  import {
    FormHelperText,
    Input,
    InputLabel,
    InputBase,
  } from "@material-ui/core";
  import { reportFilterFuel } from "./ReportObj";
import { ToastError } from "../../services/ToastMsg";
import { getRequest } from "../../services/ApiServices";
import { getCookie } from "../../services/Cookies";
import FilterComponents from "../FilterComponents/FilterComponents";
import { FilterComponentObj } from "../FilterComponents/FilterComponentObj";

export default function FiltersReportFuel(props){
    const [formObj, setFormObj] = useState(reportFilterFuel);
    const { filterReportFual, clearFilter,FormatClearFilter} = props;
    const [filtercomObj, setfiltercomObj] = React.useState(FilterComponentObj);
    const [shipNameData, setShipNameData] = useState([]);
    const [shipNamesMultipleSelect, setShipNamesMultipleSelect] = useState([]);
    const [GlobalFilterSettingValue, setGlobalFilterSettingValue] = React.useState(localStorage.getItem('GlobalFilterSetting'));

    const applyFilter = (Obj) => {
        filterReportFual(Obj);
        FormatClearFilter(Obj);
      };
    
      const onClearFilter = (Obj) => {
        filterReportFual(Obj);
        setFormObj(reportFilterFuel);
        setShipNamesMultipleSelect([]);
        FormatClearFilter(Obj)
        clearFilter();
      };

      const fetchShipNameData = async () => {
        const customerKey = getCookie("clientId");
        const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Ship/${customerKey}`;
        await getRequest(url)
          .then((res) => {
            //console.log("Responce", res);
            if (res.status == 200) {
              //  dispatch({ type: LOADING, payload: false });
              setShipNameData(res.data);
              // console.log(shipNameData);
            } else {
              ToastError(res.data.message);
            }
          })
          .catch((error) => {
          });
      };

      const defaultValue = (val) => {
        if (val !== "" && val !== undefined && val !== "null") {
            let Obj = JSON.parse(val);
            setfiltercomObj(Obj);
            console.log('getcookievalue', formObj)
        }
    };
      React.useEffect(() => {
        fetchShipNameData();
        defaultValue(GlobalFilterSettingValue);
      }, []);

    return(
        <div>
        <Box className="decarbox1" component="div" style={{padding: "20px"}}  >
         <FilterComponents screen={"reports"} filtervalue={["CustomerName","ShipName_imo","Bunkerport","Samplenumber","Bargename","Fuelgrade",'FuelOffSpec',"Lab_Fqt","FqtReportDateComponent","Service_type","Fuelsupplier"]} applyFilter={applyFilter} reset={onClearFilter}
         defaultDate={props.defaultDate}
         />
       </Box>
       </div>
    )
};